import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGE1 = isWebp ? buildImageURL('/doc-1.webp') : buildImageURL('/doc-1.png');
const IMAGE2 = isWebp ? buildImageURL('/doc-2.webp') : buildImageURL('/doc-2.png');
const IMAGE3 = isWebp ? buildImageURL('/doc-3.webp') : buildImageURL('/doc-3.png');
// const IMAGE1_M = buildImageURL('/doc-1.jpg');
// const IMAGE2_M = buildImageURL('/doc-2.jpg');
// const IMAGE3_M = buildImageURL('/doc-3.jpg');

const IMAGE1_M = isWebp ? buildImageURL('/doc-m-1.webp') : buildImageURL('/doc-m-1.png');
const IMAGE2_M = isWebp ? buildImageURL('/doc-m-2.webp') : buildImageURL('/doc-m-2.png');
const IMAGE3_M = isWebp ? buildImageURL('/doc-m-3.webp') : buildImageURL('/doc-m-3.png');

const track = getTrack({ block: 29 });
const track1 = getTrack({ block: 30 });
const track2 = getTrack({ block: 31 });

export function Doc({mobile = false}) {
  return (
    <div className="page-section section-doc inverted">
      <div className="wrapper">
        <div className="item item-1" data-track={track}>
          {!mobile && <h6>多设备协同</h6>}
          <Image src={mobile ? IMAGE1_M : IMAGE1} />
          <div className="txt-box">
            {mobile && <h6>多设备协同</h6>}
            <p>通过多屏互动可在电脑上操控手机应用，同时，网页传扫码可实现文件跨设备传输，省时更省心。</p>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div className="item item-2" data-track={track1}>
          {!mobile && <h6>文档轻编辑</h6>}
          <Image src={mobile ? IMAGE2_M : IMAGE2} />
          <div className="txt-box">
            {mobile && <h6>文档轻编辑</h6>}
            <p>你可以轻松在手机上编辑文档的字体样式、段落、审阅或者输出成 PDF。多种编辑功能、支持 42 种文件格式，轻松搞定各种文档，让你的编辑更高效。</p>
          </div>
        </div>
        <div className="item item-3" data-track={track2}>
          {!mobile && <h6>无线打印</h6>}
          <Image src={mobile ? IMAGE3_M : IMAGE3} />
          <div className="txt-box">
            {mobile && <h6>无线打印</h6>}
            <p>无线打印支持 24 个主流品牌超过 4000 款打印机机型以及多种文件格式。</p>
          </div>
        </div>
      </div>
    </div>
  );
}
